import React, { createContext, useContext, useEffect, useState } from 'react';
import ru from '@/i18n/ru.json';
import en from '@/i18n/en.json';
import fr from '@/i18n/fr.json';

const DICTS = { ru, en, fr };
const LANGS = [
  { code: 'en', label: 'EN', full: 'English' },
  { code: 'ru', label: 'RU', full: 'Русский' },
  { code: 'fr', label: 'FR', full: 'Français' },
];

const LanguageContext = createContext({ lang: 'en', t: (k) => k, setLang: () => {}, langs: LANGS });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('concorde_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('concorde_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (code) => {
    if (DICTS[code]) setLangState(code);
  };

  const t = (path, vars = {}) => {
    const parts = String(path).split('.');
    let cur = DICTS[lang] || DICTS.en;
    for (const p of parts) {
      if (cur && typeof cur === 'object' && p in cur) cur = cur[p];
      else return path;
    }
    if (typeof cur === 'string') {
      let out = cur;
      Object.entries(vars).forEach(([k, v]) => { out = out.replace(`{${k}}`, v); });
      return out;
    }
    return cur;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
